var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container schedule-list" },
    [
      _c("parameters-dialog", {
        attrs: {
          visible: _vm.isParametersVisible,
          param: _vm.scheduleForm.param
        },
        on: {
          confirm: _vm.onParametersConfirm,
          close: function($event) {
            _vm.isParametersVisible = false
          }
        }
      }),
      _c("v-tour", {
        attrs: {
          name: "schedule-list",
          steps: _vm.tourSteps,
          callbacks: _vm.tourCallbacks,
          options: _vm.$utils.tour.getOptions(true)
        }
      }),
      _c("v-tour", {
        attrs: {
          name: "schedule-list-add",
          steps: _vm.tourAddSteps,
          callbacks: _vm.tourAddCallbacks,
          options: _vm.$utils.tour.getOptions(true)
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t(_vm.dialogTitle),
            visible: _vm.dialogVisible,
            width: "640px",
            "before-close": _vm.onDialogClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "scheduleForm",
              staticClass: "add-form",
              attrs: {
                "label-width": "180px",
                model: _vm.scheduleForm,
                "inline-message": true,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Schedule Name"),
                    prop: "name",
                    required: ""
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      id: "schedule-name",
                      placeholder: _vm.$t("Schedule Name")
                    },
                    model: {
                      value: _vm.scheduleForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.scheduleForm, "name", $$v)
                      },
                      expression: "scheduleForm.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Run Type"),
                    prop: "run_type",
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        id: "run-type",
                        placeholder: _vm.$t("Run Type")
                      },
                      model: {
                        value: _vm.scheduleForm.run_type,
                        callback: function($$v) {
                          _vm.$set(_vm.scheduleForm, "run_type", $$v)
                        },
                        expression: "scheduleForm.run_type"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          value: "all-nodes",
                          label: _vm.$t("All Nodes")
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          value: "selected-nodes",
                          label: _vm.$t("Selected Nodes")
                        }
                      }),
                      _c("el-option", {
                        attrs: { value: "random", label: _vm.$t("Random") }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.scheduleForm.run_type === "selected-nodes"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Nodes"),
                        prop: "node_ids",
                        required: ""
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            id: "node-ids",
                            placeholder: _vm.$t("Nodes"),
                            multiple: "",
                            filterable: ""
                          },
                          model: {
                            value: _vm.scheduleForm.node_ids,
                            callback: function($$v) {
                              _vm.$set(_vm.scheduleForm, "node_ids", $$v)
                            },
                            expression: "scheduleForm.node_ids"
                          }
                        },
                        _vm._l(_vm.nodeList, function(op) {
                          return _c("el-option", {
                            key: op._id,
                            attrs: {
                              value: op._id,
                              label: op.name,
                              disabled: op.status === "offline"
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isDisabledSpiderSchedule
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Spider"),
                        prop: "spider_id",
                        required: ""
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            id: "spider-id",
                            placeholder: _vm.$t("Spider"),
                            filterable: "",
                            disabled: _vm.isDisabledSpiderSchedule
                          },
                          on: { change: _vm.onSpiderChange },
                          model: {
                            value: _vm.scheduleForm.spider_id,
                            callback: function($$v) {
                              _vm.$set(_vm.scheduleForm, "spider_id", $$v)
                            },
                            expression: "scheduleForm.spider_id"
                          }
                        },
                        _vm._l(_vm.allSpiderList, function(op) {
                          return _c("el-option", {
                            key: op._id,
                            attrs: {
                              value: op._id,
                              label: op.display_name + " (" + op.name + ")",
                              disabled: _vm.isDisabledSpider(op)
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Spider"), required: "" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            value: _vm.spiderId,
                            placeholder: _vm.$t("Spider"),
                            filterable: "",
                            disabled: _vm.isDisabledSpiderSchedule
                          }
                        },
                        _vm._l(_vm.allSpiderList, function(op) {
                          return _c("el-option", {
                            key: op._id,
                            attrs: {
                              value: op._id,
                              label: op.display_name + " (" + op.name + ")",
                              disabled: _vm.isDisabledSpider(op)
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
              _vm.spiderForm.is_scrapy
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Scrapy Spider"),
                        prop: "scrapy_spider",
                        required: "",
                        "inline-message": ""
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("Scrapy Spider"),
                            disabled: _vm.isLoading
                          },
                          model: {
                            value: _vm.scheduleForm.scrapy_spider,
                            callback: function($$v) {
                              _vm.$set(_vm.scheduleForm, "scrapy_spider", $$v)
                            },
                            expression: "scheduleForm.scrapy_spider"
                          }
                        },
                        _vm._l(_vm.spiderForm.spider_names, function(s) {
                          return _c("el-option", {
                            key: s,
                            attrs: { label: s, value: s }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.spiderForm.is_scrapy
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Scrapy Log Level"),
                        prop: "scrapy_spider",
                        required: "",
                        "inline-message": ""
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("Scrapy Log Level") },
                          model: {
                            value: _vm.scheduleForm.scrapy_log_level,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.scheduleForm,
                                "scrapy_log_level",
                                $$v
                              )
                            },
                            expression: "scheduleForm.scrapy_log_level"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { value: "INFO", label: "INFO" }
                          }),
                          _c("el-option", {
                            attrs: { value: "DEBUG", label: "DEBUG" }
                          }),
                          _c("el-option", {
                            attrs: { value: "WARN", label: "WARN" }
                          }),
                          _c("el-option", {
                            attrs: { value: "ERROR", label: "ERROR" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("Cron"), prop: "cron", required: "" }
                },
                [
                  _c("el-input", {
                    ref: "cron",
                    staticClass: "cron",
                    staticStyle: { width: "calc(100% - 100px)" },
                    attrs: {
                      id: "cron",
                      placeholder:
                        "" +
                        _vm.$t("[minute] [hour] [day] [month] [day of week]")
                    },
                    model: {
                      value: _vm.scheduleForm.cron,
                      callback: function($$v) {
                        _vm.$set(_vm.scheduleForm, "cron", $$v)
                      },
                      expression: "scheduleForm.cron"
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass: "cron-edit",
                      staticStyle: { width: "100px" },
                      attrs: { type: "primary", icon: "el-icon-edit" },
                      on: { click: _vm.onShowCronDialog }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Edit")) + " ")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Execute Command"), prop: "cmd" } },
                [
                  _c("el-input", {
                    attrs: {
                      id: "cmd",
                      placeholder: _vm.$t("Execute Command"),
                      disabled: ""
                    },
                    model: {
                      value: _vm.spiderForm.cmd,
                      callback: function($$v) {
                        _vm.$set(_vm.spiderForm, "cmd", $$v)
                      },
                      expression: "spiderForm.cmd"
                    }
                  })
                ],
                1
              ),
              _vm.spiderForm.type === "customized"
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Parameters"), prop: "param" } },
                    [
                      _vm.spiderForm.is_scrapy
                        ? [
                            _c("el-input", {
                              staticClass: "param-input",
                              attrs: { placeholder: _vm.$t("Parameters") },
                              model: {
                                value: _vm.scheduleForm.param,
                                callback: function($$v) {
                                  _vm.$set(_vm.scheduleForm, "param", $$v)
                                },
                                expression: "scheduleForm.param"
                              }
                            }),
                            _c("el-button", {
                              staticClass: "param-btn",
                              attrs: { type: "primary", icon: "el-icon-edit" },
                              on: { click: _vm.onOpenParameters }
                            })
                          ]
                        : [
                            _c("el-input", {
                              attrs: { placeholder: _vm.$t("Parameters") },
                              model: {
                                value: _vm.scheduleForm.param,
                                callback: function($$v) {
                                  _vm.$set(_vm.scheduleForm, "param", $$v)
                                },
                                expression: "scheduleForm.param"
                              }
                            })
                          ]
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Schedule Description"),
                    prop: "description"
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      id: "schedule-description",
                      type: "textarea",
                      placeholder: _vm.$t("Schedule Description")
                    },
                    model: {
                      value: _vm.scheduleForm.description,
                      callback: function($$v) {
                        _vm.$set(_vm.scheduleForm, "description", $$v)
                      },
                      expression: "scheduleForm.description"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.onCancel } },
                [_vm._v(_vm._s(_vm.$t("Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    id: "btn-submit",
                    size: "small",
                    type: "primary",
                    disabled: _vm.isLoading
                  },
                  on: { click: _vm.onAddSubmit }
                },
                [_vm._v(_vm._s(_vm.$t("Submit")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("Tasks"),
            visible: _vm.isViewTasksDialogVisible,
            width: "calc(100% - 240px)",
            "before-close": function() {
              return (this$1.isViewTasksDialogVisible = false)
            }
          },
          on: {
            "update:visible": function($event) {
              _vm.isViewTasksDialogVisible = $event
            }
          }
        },
        [_c("schedule-task-list", { ref: "schedule-task-list" })],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "生成 Cron", visible: _vm.cronDialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.cronDialogVisible = $event
            }
          }
        },
        [
          _c("vue-cron-linux", {
            ref: "vue-cron-linux",
            attrs: { data: _vm.scheduleForm.cron, i18n: _vm.lang },
            on: { submit: _vm.onCronChange }
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.cronDialogVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.onCronDialogSubmit }
                },
                [_vm._v(_vm._s(_vm.$t("Confirm")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("crawl-confirm-dialog", {
        attrs: {
          visible: _vm.crawlConfirmDialogVisible,
          "spider-id": _vm.scheduleForm.spider_id
        },
        on: {
          close: function() {
            return (_vm.crawlConfirmDialogVisible = false)
          },
          confirm: function() {
            return (_vm.crawlConfirmDialogVisible = false)
          }
        }
      }),
      _c("batch-add-schedule-dialog", {
        attrs: { visible: _vm.batchAddDialogVisible },
        on: { close: _vm.onBatchAddClose, confirm: _vm.onBatchAddConfirm }
      }),
      _c(
        "el-card",
        { staticClass: "schedule-list", staticStyle: { "border-radius": "0" } },
        [
          _c("div", { staticClass: "filter" }, [
            _c(
              "div",
              { staticClass: "right" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn-add",
                    attrs: {
                      size: "small",
                      type: "success",
                      icon: "el-icon-document-copy"
                    },
                    on: { click: _vm.onBatchAdd }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("Batch Add")) + " ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn-add",
                    attrs: {
                      size: "small",
                      type: "success",
                      icon: "el-icon-plus"
                    },
                    on: { click: _vm.onAdd }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("Add Schedule")) + " ")]
                ),
                _vm.selectedSchedules.length > 0
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn-enable",
                        attrs: {
                          size: "small",
                          type: "primary",
                          icon: "el-icon-check"
                        },
                        on: { click: _vm.onBatchEnable }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Enable")) + " ")]
                    )
                  : _vm._e(),
                _vm.selectedSchedules.length > 0
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn-disable",
                        attrs: {
                          size: "small",
                          type: "info",
                          icon: "el-icon-close"
                        },
                        on: { click: _vm.onBatchDisable }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Disable")) + " ")]
                    )
                  : _vm._e(),
                _vm.selectedSchedules.length > 0
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn-delete",
                        attrs: {
                          size: "small",
                          type: "danger",
                          icon: "el-icon-delete"
                        },
                        on: { click: _vm.onRemoveSelectedSchedules }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Remove")) + " ")]
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _c(
            "el-table",
            {
              ref: "table",
              staticClass: "table",
              attrs: {
                data: _vm.filteredTableData,
                "header-cell-style": {
                  background: "rgb(48, 65, 86)",
                  color: "white"
                },
                border: "",
                "row-key": "_id"
              },
              on: { "selection-change": _vm.onScheduleSelect }
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "45",
                  align: "center",
                  "reserve-selection": ""
                }
              }),
              _vm._l(_vm.columns, function(col) {
                return [
                  col.name === "status"
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          property: col.name,
                          label: _vm.$t(col.label),
                          sortable: col.sortable,
                          align: col.align,
                          width: col.width
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  scope.row[col.name] === "error"
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: _vm.$t(
                                              scope.row["message"]
                                            ),
                                            placement: "top"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-tag",
                                            {
                                              staticClass: "status-tag",
                                              attrs: { type: "danger" }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row[col.name]
                                                      ? _vm.$t(
                                                          scope.row[col.name]
                                                        )
                                                      : _vm.$t("NA")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "el-tag",
                                        { staticClass: "status-tag" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row[col.name]
                                                  ? _vm.$t(scope.row[col.name])
                                                  : _vm.$t("NA")
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : col.name === "run_type"
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: { label: _vm.$t(col.label), width: col.width },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  scope.row.run_type === "all-nodes"
                                    ? [_vm._v(_vm._s(_vm.$t("All Nodes")))]
                                    : scope.row.run_type === "selected-nodes"
                                    ? [_vm._v(_vm._s(_vm.$t("Selected Nodes")))]
                                    : scope.row.run_type === "random"
                                    ? [_vm._v(_vm._s(_vm.$t("Random")))]
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : col.name === "node_names"
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: { label: _vm.$t(col.label), width: col.width },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.nodes
                                          .map(function(d) {
                                            return d.name
                                          })
                                          .join(", ")
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : col.name === "enable"
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: { label: _vm.$t(col.label), width: col.width },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("el-switch", {
                                    attrs: {
                                      "active-color": "#13ce66",
                                      "inactive-color": "#ff4949"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.onEnabledChange(scope.row)
                                      }
                                    },
                                    model: {
                                      value: scope.row.enabled,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "enabled", $$v)
                                      },
                                      expression: "scope.row.enabled"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          property: col.name,
                          label: _vm.$t(col.label),
                          sortable: col.sortable,
                          align: col.align,
                          width: col.width
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    " " + _vm._s(scope.row[col.name]) + " "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                ]
              }),
              _c("el-table-column", {
                staticClass: "actions",
                attrs: {
                  label: _vm.$t("Action"),
                  align: "left",
                  width: "170",
                  fixed: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: { content: _vm.$t("Edit"), placement: "top" }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "warning",
                                icon: "el-icon-edit",
                                size: "mini"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onEdit(scope.row)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("Remove"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "danger",
                                icon: "el-icon-delete",
                                size: "mini"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onRemove(scope.row)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("View Tasks"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-search",
                                size: "mini"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onViewTasks(scope.row)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: { content: _vm.$t("Run"), placement: "top" }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "success",
                                icon: "fa fa-bug",
                                size: "mini"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onRun(scope.row)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }